import React from "react"

import Grid from "#blocks/Grid"
import SessionBox from "#blocks/SessionBox"
import { AttendanceStatus } from "#customTypes/types"

type SessionGridItem = {
  sessionId: string | null | undefined
  status: AttendanceStatus
  isSelected: boolean
  isNewlySelected?: boolean
  isDropped?: boolean
  isDisabled: boolean
  isPast?: boolean
  disabledReason?: string
  onClick: () => void
  key: string
}

const SessionGrid = ({
  items,
  columns = 4,
  renderEmptySlot,
}: {
  items: (SessionGridItem | null)[]
  columns?: number
  renderEmptySlot?: (index: number) => React.ReactNode
}) => {
  return (
    <Grid columns={columns} rowGap={10} columnGap={10}>
      {items.map((item, index) => {
        // If item is null/undefined, render empty slot if provided
        if (!item && renderEmptySlot) {
          return (
            <React.Fragment key={`empty-${index}`}>
              {renderEmptySlot(index)}
            </React.Fragment>
          )
        }
        if (!item) return null

        return (
          <SessionBox
            key={item.key}
            sessionId={item.sessionId}
            status={item.status}
            isSelected={item.isSelected}
            isNewlySelected={item.isNewlySelected}
            isDropped={item.isDropped}
            isDisabled={item.isDisabled}
            isPast={item.isPast}
            disabledReason={item.disabledReason}
            onClick={item.onClick}
          />
        )
      })}
    </Grid>
  )
}

export default SessionGrid
